import { Component, OnInit } from "@angular/core";
import { SectorsAndIndustriesPageDataService } from "../sectors-and-industries-page-data-service";

@Component({
  selector: "app-sectors-and-industries-summary",
  templateUrl: "./sectors-and-industries-summary.component.html",
  styleUrls: ["./sectors-and-industries-summary.component.scss"],
})
export class SectorsAndIndustriesSummaryComponent implements OnInit {
  indystryAnalysisTemplatesCount: number;
  companiesCoveredCount: number;
  loading = true;
  constructor(private dataService: SectorsAndIndustriesPageDataService) {}

  ngOnInit() {
    this.dataService.getCompGroupsAndCompaniesCoveredCount().subscribe(
      (data) => {
        this.indystryAnalysisTemplatesCount =
          data.sector_industry_header.total_va_comps_group;
        this.companiesCoveredCount =
          data.sector_industry_header.total_companies_covered;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        console.error(err);
      },
    );
  }
}
